<div class="header-text">Witnesses</div>
<div id="witnessSection">
    @for (witness of incidentReport.witnesses; track $index) {
        <div class="row mb-3 mt-3">
            <div class="col-sm-6">
                <label class="form-label">Witness <span class="text-danger">*</span></label>
                <pictured-item-select-box [value]="witness.employeeId" (valueChange)="onWitnessChange($event, witness)"
                                        [dataSource]="employeesDataSource" [readOnly]="witness.isNotEmployee || isReadOnly"
                                        [validators]="witness.isNotEmployee ? [] : [{type: 'required'}]">
                </pictured-item-select-box>
                <div class="mt-2">
                    <dx-check-box [(value)]="witness.isNotEmployee" text="Not an employee"
                                (onValueChanged)="onWitnessToggle($event.value, witness)" [readOnly]="isReadOnly">
                    </dx-check-box>
                </div>
            </div>

            @if (witness.isNotEmployee) {
                <div class="col-sm-5">
                    <div>
                        <label class="form-label">Name <span class="text-danger">*</span></label>
                        <dx-text-box stylingMode="filled" [(value)]="witness.externalName" maxLength="100" placeholder="Enter name"
                                    [readOnly]="isReadOnly">
                            <dx-validator>
                                <dxi-validation-rule max="100" type="required" message="Name is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            }
            @if ($index > 0 && !isReadOnly) {
                <div class="col-sm-1 d-flex align-items-center">
                    <dx-button icon="trash" stylingMode="text" type="danger" (onClick)="removeWitness($index)" class="ms-2"></dx-button>
                </div>
            }
        </div>
    }
    @if (!isReadOnly) {
        <div class="mt-2">
            <dx-button text="Add witness" icon="add" type="default" stylingMode="outlined" (onClick)="addWitness()"></dx-button>
        </div>
    }
</div>
